module.exports = __webpack_public_path__ + "static/media/Trucks.de16b7b6.jpg";